import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from './../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-config-edit',
  templateUrl: './detalhe-projeto-indicadores-config-edit.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-config-edit.component.scss']
})
export class DetalheProjetoIndicadoresConfigEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit {

  idProjeto: number;
  indicador: IndicadoresProjeto;
  cloneIndicador: boolean;
  checkClone: any;
  infoProjeto: ProjetoCadastro;
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;

  constructor(
    private myService: IndicadoresProjetoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.list = this.activatedRoute.snapshot.data['list'];
      this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];
      this.cloneIndicador = this.activatedRoute.snapshot.data['clone'];
      this.checkClone = this.activatedRoute.snapshot.queryParams['chkCopyAcPrtActionIndicator'];
      this.initForm();
    });

    if (this.cloneIndicador) {
      EventSharedService.get('reloadLayout').emit();
    }
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      agreed_objective: new FormControl(''),
      description: new FormControl(''),
      description_goal: new FormControl(''),
      unit_id: new FormControl(null, [Validators.required]),
      year: new FormControl(null, [Validators.required]),
      year_goal: new FormControl(null),
      data_source: new FormControl(null),
      manager: new FormControl(null),
      adjunct: new FormControl(null),
      table_mod_id: new FormControl({ value: this.list?.select_table_mod_id ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      numerator_label: new FormControl(null, [Validators.required]),
      denominator_label: new FormControl(null, [Validators.required]),
      period_mod_id: new FormControl({ value: this.list?.select_period_mod_id ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      month1: new FormControl(null, this.list?.month1_enable ? Validators.required : []),
      month2: new FormControl(null, this.list?.month2_enable ? Validators.required : []),
      polarity: new FormControl({ value: this.list?.select_polarity ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      accum: new FormControl({ value: this.list?.select_accum ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      decimal_places: new FormControl({ value: "0", disabled: this.entity?.editSummed }, [Validators.required]),
      accum_show: new FormControl(null, [Validators.required]),
      accum_table: new FormControl(null, [Validators.required]),
      status_ok: new FormControl(null, this.entity ? Validators.required : []),
      status_warn: new FormControl(null, this.entity ? Validators.required : []),
      status_alert: new FormControl(null, this.entity ? Validators.required : []),
      status_intensive: new FormControl(null, this.list?.level_mon_id_enable ? Validators.required : []),
      level_mon_id: new FormControl(null, this.entity ? Validators.required : []),
      bi_theme_id: new FormControl(null),
      program_ar: new FormControl(null, this.list?.level_mon_id_enable ? Validators.required : []),
      program_avancar: new FormControl(null, this.list?.program_avancar_enable ? Validators.required : []),
      monitor_id: new FormControl(null, this.list?.level_mon_id_enable ? Validators.required : []),
      prod_id: new FormControl(null),
      disabled: new FormControl(null, this.entity ? Validators.required : []),
      ref_ind_id: new FormControl(null),
      parent_ind_id: new FormControl(null),
      irfe_id: new FormControl(null),
      chkCopyAcPrtActionIndicator: new FormControl(null),
    });

    if (this.entity) {
      this.form.patchValue(this.entity);

      this.audit = {
        ind_id: this.entity.id
      };

      if (this.cloneIndicador) {
        this.form.get('year').setValue(null);
      }

      if (this.entity?.readonly) {
        this.form.disable();
      }
    }

    this.tableModRefresh(null, this.entity?.table_mod_id ?? this.list?.select_table_mod_id);
    this.accumTableChange();
    this.accumChange();
  }

  voltar() {    
    if (this.entity?.id && !this.cloneIndicador) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.entity?.id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores']);
    }
  }

  getDataCreate(): IndicadoresProjeto {
    let data: IndicadoresProjeto;
    data = Object.assign({}, data, this.form.value);

    data.pf_id = this.idProjeto;

    if (this.cloneIndicador) {
      data.copy_ind_id = this.entity?.id;
      if (this.checkClone === 'true') {
        data.chkCopyAcPrtActionIndicator = this.checkClone;
      }
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      
      if (this.entity?.id && !this.cloneIndicador) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Indicador alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              // this.increaseIndicadoresItens();
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'indicadores', res.id, 'editar']);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  // increaseIndicadoresItens() {
  //   this.infoProjeto.menu['indicadores'].itens++;
  //   this.pesquisaGeralService.setInfoProject(this.infoProjeto);
  // }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  maskNumber(event, field) {
    let value = event.target?.value.replace(/\D/i, '');
    this.form.get(field).setValue(value);
  }

  tableModRefresh(event, value_table_mod_id = null) {
    const value = value_table_mod_id ? value_table_mod_id : event?.id;
    const validators = value == 2 ? [Validators.required] : [];
    //2
    this.form.get('numerator_label').setValidators(validators);
    this.form.get('denominator_label').setValidators(validators);
    this.form.get('numerator_label').updateValueAndValidity();
    this.form.get('denominator_label').updateValueAndValidity();
    if ((value_table_mod_id === null && event?.id != 2)) {
      this.form.get('numerator_label').setValue(null);
      this.form.get('denominator_label').setValue(null);
    }
    if(value == 2){
      this.form.get('accum_show').setValue(false);
    }
  }

  formatarMedidaFisica(field: string, decimalPlacesValue = 2) {
    let formValue = this.form.get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(formValue, decimalPlacesValue);
    this.form.get(field).setValue(value);
  }

  accumChange() {
    let value = this.form.get('accum')?.value;
    if (value === '0') {
      this.form.get('accum_show').enable();
      this.form.get('accum_table').enable();
    } else if (value === '1') {
      this.form.get('accum_show').setValue('0');
      this.form.get('accum_table').setValue('0');
      this.form.get('accum_show').disable();
      this.form.get('accum_table').disable();
    }
  }

  accumTableChange() {
    let value = this.form.get('accum_table')?.value;
    if (value === '1') {
      this.form.get('accum_show').setValue('0');
      this.form.get('accum_show').disable();
    } else {
      this.form.get('accum_show').enable();
    }
  }

  levelMonChange() {
    let levelMonValue = this.form.get('level_mon_id').value;
    if (levelMonValue == 1) {
      this.list.level_mon_id_enable = true;
      this.form.get("monitor_id").addValidators([Validators.required]);
      this.form.get("monitor_id").updateValueAndValidity();
    } else {
      this.list.level_mon_id_enable = false;
      this.list.program_avancar_enable = false;
      this.form.get("monitor_id").removeValidators([Validators.required]);
      this.form.get("monitor_id").updateValueAndValidity();
      this.form.get("bi_theme_id").removeValidators([Validators.required]);
      this.form.get("bi_theme_id").updateValueAndValidity();
      this.form.get('program_ar').setValue('0');
      this.form.get('program_avancar').setValue('0');
    }
  }

  programArChange() {
    let programArValue = this.form.get('program_ar').value;

    if (programArValue == 1) {
      this.list.program_avancar_enable = true;
      this.form.get("bi_theme_id").addValidators([Validators.required]);
      this.form.get("bi_theme_id").updateValueAndValidity();
    } else {
      this.list.program_avancar_enable = false;
      this.form.get("bi_theme_id").removeValidators([Validators.required]);
      this.form.get("bi_theme_id").updateValueAndValidity();
      this.form.get('program_avancar').setValue('0');
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    this.myService.delete(this.entity.id).subscribe({
      next: (res) => {
        // this.decreaseIndicadoresItens();
        this.loaded();
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'indicadores']);
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

  decimalChange(){
    this.formatarMedidaFisica('year_goal', this.form.get('decimal_places').value)
  }

  // decreaseIndicadoresItens() {
  //   this.infoProjeto.menu['indicadores'].itens--;
  //   this.pesquisaGeralService.setInfoProject(this.infoProjeto);
  // }
}
